import { EntityType } from './entity-type';
import { StringFilter } from './string-filter';

export class RiskTemplateFilter {
  entityTypeArea?: EntityType;
  name?: StringFilter;
  templateType?: string;
}
